<template><div><h1 id="auslandische-plz" tabindex="-1"><a class="header-anchor" href="#auslandische-plz"><span>Ausländische PLZ</span></a></h1>
<p>Ausländische PLZ — Verzeichnis ausländischer Postleitzahlen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle können ausländische Postleitzahlen gespeichert werden. Sie dient der Validierung von Eingaben in der Adresse und muss manuell durch den Kunden gepflegt werden.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Postdaten → Ausländische PLZ</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>PstlzA</dt>
<dd>Postleitzahl, 6-stellig, alphanumerisch</dd>
<dt>PZ</dt>
<dd>Postleitzahl-Zusatz, 2-stellig, alphanumerisch</dd>
</dl>
<p>Ortsbezeichnung ungekürzt
:</p>
<dl>
<dt>Ortsabkürzung 18</dt>
<dd>Ortsbezeichnung, 18-stellig, alphanumerisch, gemäss Weltpostverband zur korrekten Adressierung notwendig</dd>
<dt>Alpha</dt>
<dd>5-stelliges, numerisches Feld, welches die Sortierung alphanumerischer PLZ zusammen mit den in der Schweiz üblichen numerischen PLZ erlaubt</dd>
<dt>1</dt>
<dd>Sprachcode1: Hauptsprache</dd>
<dt>2</dt>
<dd>Sprachcode2: Zweitsprache</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/postdaten_verarbeiten.html" title="5. Post-Daten verarbeiten">Postdaten verarbeiten</RouteLink></p>
</div></template>


